import React from 'react';
import OrangeMaskIcon from 'assets/orange_mask_icon.svg';
import { ChatAdvantage } from 'services/api/chatsApi';
import styled from 'styled-components';

interface AdvantagesSectionProps {
  advantages: ChatAdvantage[];
}

const AdvantagesSection: React.FC<AdvantagesSectionProps> = ({ advantages }) => {
  if (!advantages || advantages.length === 0) return null;

  return (
    <AdvantagesSectionWrapper>
      <AdvantagesTitle>Advantages</AdvantagesTitle>
      <AdvantagesGrid>
        {advantages.map((advantage, index) => (
          <AdvantageCard key={index}>
            <AdvantageIcon>
              <IconImage src={OrangeMaskIcon} alt="Advantage Icon" />
            </AdvantageIcon>
            <AdvantageTitle>{advantage.title}</AdvantageTitle>
            <AdvantageDescription>{advantage.description}</AdvantageDescription>
          </AdvantageCard>
        ))}
      </AdvantagesGrid>
    </AdvantagesSectionWrapper>
  );
};

export default AdvantagesSection;

const AdvantagesSectionWrapper = styled.section`
  margin-bottom: 48px;
  
  @media (max-width: 968px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const AdvantagesTitle = styled.h2`
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
  color: #FFF;
  text-align: left;
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 24px;
  }
`;

const AdvantagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const AdvantageCard = styled.div`
  border-radius: 12px;
  border: 1px solid  #282828;
  background: #1D1D1D;
  padding: 20px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    padding: 16px;
    min-height: 140px;
  }
`;

const AdvantageIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;

const IconImage = styled.img`
  width: 24px;
  height: 24px;
`;

const AdvantageTitle = styled.h3`
  color: #FFF;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 110% */
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 8px;
  }
`;

const AdvantageDescription = styled.p`
  overflow: hidden;
  color:  #FFF;
  text-overflow: ellipsis;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; 
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  align-self: stretch;
  flex-grow: 1;
  
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 16px;
  }
`;